import { render } from "./loading.html?vue&type=template&id=149db7d8&scoped=true&external"
import script from "./loading.ts?vue&type=script&lang=js&external"
export * from "./loading.ts?vue&type=script&lang=js&external"

import "./loading.scss?vue&type=style&index=0&id=149db7d8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149db7d8"],['__file',"src/components/ui/loading/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "149db7d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('149db7d8', __exports__)) {
    api.reload('149db7d8', __exports__)
  }
  
  module.hot.accept("./loading.html?vue&type=template&id=149db7d8&scoped=true&external", () => {
    api.rerender('149db7d8', render)
  })

}


export default __exports__